import { UI_INITIAL_STATE } from '../../../../../utils/constants'
import { getIJoistManufacturer } from '../../../../../utils/actions'
import { createGenericSlice } from '../../../../../utils/slices'

export const uiSlice = createGenericSlice({
  name: 'ui',
  initialState: {
    ...UI_INITIAL_STATE,
    illustrationErrors: null,
    inputErrors: null,
    inputWarning: false,
    manufacturerData: null,
    graphicsData: null,
    activeTab: 'output',
  },
  reducers: {
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload
    },
    updateInputErrors: (state, { payload }) => {
      state.inputErrors = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getIJoistManufacturer.fulfilled, (state, action) => {
      state.manufacturerData = action.payload
    })
  },
})

export const uiActions = uiSlice.actions
